export const cmpntGroup = { dashboard: false, jobs:false, serverInfo: false, user:false, logs: false, syncService:false };